module.exports = {
	"id": "/transfer",
	"properties": {
		"transferId": {
			"type": "integer",
			"required": true
		},
		"playerId": {
			"type": "integer",
			"required": true
		},
		"fromTeamId": {
			"type": "integer",
			"required": true
		},
		"toTeamId": {
			"type": "integer",
			"required": true
		},
		"fromTournamentTemplateId": {
			"type": "integer",
			"required": true
		},
		"toTournamentTemplateId": {
			"type": "integer",
			"required": true
		}
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ../src/config/message_schemas/triggers/transfer.json
 ** module id = 1837
 ** module chunks = 0
 **/